module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-light"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "id": "sidebarCollapse"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fas fa-align-left"
  }), _vm._v(" "), _c('span', [_vm._v("Toggle")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d379425c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Layout/components/TopNavigation/index.vue
// module id = 1230
// module chunks = 1